import { render, staticRenderFns } from "./text1.vue?vue&type=template&id=f1cf4760&scoped=true"
import script from "./text1.vue?vue&type=script&lang=js"
export * from "./text1.vue?vue&type=script&lang=js"
import style0 from "./text1.vue?vue&type=style&index=0&id=f1cf4760&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1cf4760",
  null
  
)

export default component.exports